export class WbLightbeans {

  constructor() {
    this.init();
  }

  init() {
    const _this = this;

    return new Promise((resolve) => {
      document
        .querySelector('body')
        ._addCustomEventListener('click', '[data-lightbeans-3d]', _this.openModal);

      resolve();
    });
  }

  openModal(e) {
    const event = new CustomEvent('__lb_show_popup_', {
      detail: {
        texture: e.targetElement.dataset.lightbeansLink,
        lang: e.targetElement.dataset.lightbeansLang,
      },
    });

    document.body.dispatchEvent(event);
  }

}
